<div class="signup-wrapper container-fluid">

    <div class="header border-0 animated fadeInDown" #scrollToTopRef>
        <a [routerLink]="['/shop']">
            <img class="logo" src="/assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Philly Foodworks">
        </a>
    </div>

    <div class="row alert alert-success border-0 fade show animated fadeInUp rounded-0 text-center mb-0" role="alert">
        <div class="d-flex justify-content-center align-items-end gap-2">
            50% off the best food in the city, and you support local producers. Don’t think so hard—just get a box!
            <section class="d-none d-lg-block">
                <!-- <svg width="20px" height="20px" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7 0.75C7.98438 0.75 8.85938 1.32422 9.29688 2.17188C10.1992 1.87109 11.2383 2.08984 11.9492 2.80078C12.6602 3.51172 12.8789 4.55078 12.5781 5.45312C13.4258 5.89062 14 6.76562 14 7.75C14 8.76172 13.4258 9.63672 12.5781 10.0742C12.8789 10.9766 12.6602 11.9883 11.9492 12.6992C11.2383 13.4102 10.1992 13.6289 9.29688 13.3555C8.85938 14.2031 7.98438 14.75 7 14.75C5.98828 14.75 5.11328 14.2031 4.67578 13.3555C3.77344 13.6289 2.76172 13.4102 2.05078 12.6992C1.33984 11.9883 1.12109 10.9766 1.39453 10.0742C0.546875 9.63672 0 8.76172 0 7.75C0 6.76562 0.546875 5.89062 1.39453 5.45312C1.12109 4.55078 1.33984 3.51172 2.05078 2.80078C2.76172 2.08984 3.77344 1.87109 4.67578 2.17188C5.11328 1.32422 5.98828 0.75 7 0.75ZM7.57422 4.85156C7.57422 4.55078 7.32812 4.30469 7 4.30469C6.69922 4.30469 6.45312 4.55078 6.45312 4.85156V5.07031C6.28906 5.125 6.09766 5.15234 5.93359 5.23438C5.49609 5.42578 5.11328 5.80859 5.03125 6.32812C4.97656 6.62891 5.00391 6.92969 5.14062 7.17578C5.25 7.44922 5.44141 7.61328 5.63281 7.75C5.98828 7.99609 6.42578 8.13281 6.80859 8.24219H6.86328C7.27344 8.37891 7.57422 8.48828 7.76562 8.625C7.84766 8.67969 7.875 8.73438 7.90234 8.76172C7.92969 8.78906 7.92969 8.87109 7.90234 9.00781C7.90234 9.11719 7.82031 9.22656 7.62891 9.30859C7.4375 9.39062 7.10938 9.44531 6.72656 9.36328C6.53516 9.33594 6.20703 9.22656 5.90625 9.11719C5.85156 9.11719 5.79688 9.08984 5.71484 9.0625C5.44141 8.98047 5.14062 9.11719 5.03125 9.41797C4.94922 9.69141 5.08594 10.0195 5.38672 10.1016C5.41406 10.1289 5.46875 10.1289 5.52344 10.1562C5.76953 10.2383 6.17969 10.375 6.45312 10.4297V10.6758C6.45312 10.9766 6.69922 11.2227 7 11.2227C7.32812 11.2227 7.57422 10.9766 7.57422 10.6758V10.457C7.73828 10.4297 7.90234 10.375 8.06641 10.3203C8.53125 10.1289 8.88672 9.74609 8.99609 9.17188C9.05078 8.87109 9.02344 8.59766 8.91406 8.32422C8.80469 8.05078 8.61328 7.85938 8.42188 7.72266C8.03906 7.47656 7.57422 7.3125 7.19141 7.20312H7.16406C6.75391 7.06641 6.45312 6.98438 6.26172 6.84766C6.15234 6.79297 6.125 6.73828 6.125 6.71094C6.09766 6.68359 6.09766 6.62891 6.09766 6.51953C6.125 6.4375 6.17969 6.32812 6.39844 6.24609C6.58984 6.13672 6.91797 6.10938 7.30078 6.16406C7.4375 6.19141 7.84766 6.24609 7.95703 6.30078C8.25781 6.35547 8.55859 6.19141 8.64062 5.89062C8.72266 5.61719 8.53125 5.31641 8.25781 5.23438C8.09375 5.20703 7.76562 5.125 7.57422 5.09766V4.85156Z"
                        fill="black" />
                </svg> -->
                <svg width="25" height="27" viewBox="0 0 40 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <!-- <circle cx="20.032" cy="30.4677" r="17.6392" fill="#FDDBE3" /> -->
                    <path
                        d="M11.496 9.14199C11.496 8.71678 11.6023 8.39788 11.9212 8.07897C12.187 7.81321 12.559 7.65376 12.9311 7.70691C14.0473 7.86637 16.4391 8.34473 18.2994 10.205C20.0002 11.9059 20.0002 12.7563 20.0002 12.7563C20.0002 12.7563 20.0002 11.9059 21.701 10.205C23.5613 8.34473 25.9531 7.86637 27.0693 7.70691C27.4414 7.65376 27.8134 7.81321 28.0792 8.07897C28.3981 8.39788 28.5044 8.71678 28.5044 9.14199C28.3981 10.205 27.9197 12.4905 26.3783 14.0319C24.2523 16.1579 22.6046 16.2111 20.0002 16.1579C17.3958 16.2111 15.7481 16.1579 13.622 14.0319C12.0807 12.4905 11.6023 10.205 11.496 9.14199Z"
                        fill="#98B899" />
                    <path
                        d="M12.984 21.473C16.8641 17.593 23.1359 17.593 27.016 21.473C29.7267 24.1837 30.6302 28.2764 29.2483 31.8906L26.3781 39.6507H20C19.3622 39.6507 18.7775 40.2354 18.7775 40.8732C18.7775 41.511 19.3622 42.0957 20 42.0957H25.5277L21.7008 52.5133C21.3819 53.2574 20.7973 53.7358 20 53.6826C19.2027 53.7358 18.5649 53.2043 18.2992 52.5133L10.7517 31.8906L10.6985 31.8375L16.5983 31.8906C17.2893 31.8375 17.8208 31.306 17.8208 30.6682C17.8208 30.0304 17.2361 29.4457 16.5983 29.4457L10.167 29.4988C9.90128 26.5755 10.858 23.5991 12.984 21.473Z"
                        fill="#F48C4C" />
                </svg>


            </section>
        </div>
    </div>

    <!-- Contenido principal -->
    <div class="main-pane row">
        <!-- Stepper vertical -->
        <nav class="col-12 col-md-4 col-xl-3 stepper-wrapper" aria-label="Signup steps">
            <!-- Desktop Stepper -->
            <ol class="stepper stepper-desktop list-unstyled m-0 p-0 d-none d-md-flex">
                @for (s of steps; track $index; let i = $index) {
                <li class="step" [class.active]="i===currentIndex" [class.completed]="s.completed" (click)="goTo(i)"
                    tabindex="0" role="button" [attr.aria-current]="i===currentIndex? 'step': null">
                    <div class="indicator"
                        [class.last]="s.last || (s.key === 'personal' && !svc.hasSelectedProducts())">{{ s.id }}</div>
                    <div class="meta">
                        <div class="title">{{ s.title }}</div>
                    </div>
                    @if (s.completed) {
                    <i class="fas fa-check-circle completed-icon"></i>
                    }
                </li>
                }
            </ol>

            <!-- Mobile Stepper -->
            <div class="stepper-mobile d-flex d-md-none flex-column">
                <div class="step-header">
                    <div class="step-number">STEP {{ currentIndex + 1 }}</div>
                    <div class="step-title">{{ currentStep.title }}</div>
                </div>
                <div class="step-indicators">
                    @for (s of steps; track $index; let i = $index) {
                    <div class="step-circle" [class.active]="i===currentIndex" [class.completed]="s.completed"
                        (click)="goTo(i)" tabindex="0" role="button"
                        [attr.aria-current]="i===currentIndex? 'step': null">
                        {{ s.id }}
                    </div>
                    }
                </div>
            </div>
        </nav>

        <!-- Panel del step actual -->
        <section class="col-12 col-md-8 col-xl-9 step-content" [attr.data-step]="currentStep.key">

            <div class="step-panel">
                @switch (currentStep.key) {
                @case ('delivery') {
                <app-delivery-address-step (stepCompleted)="onStepCompleted()" />
                }
                @case ('availability') {
                <app-availability-step (stepCompleted)="onStepCompleted()" />
                }
                @case ('produce') {
                <app-produce-box-step (stepCompleted)="onStepCompleted()" />
                }
                @case ('subscriptions') {
                <app-subscriptions-step (stepCompleted)="onStepCompleted()" />
                }
                @case ('personal') {
                <app-personal-info-step (stepCompleted)="onStepCompleted()" />
                }
                @case ('payment') {
                @if (svc.hasSelectedProducts() || svc.getIsAbandonedFlow() || currentStep.key === 'payment') {
                <app-payment-step />
                }
                }
                }
            </div>

        </section>
    </div>

</div>

<section class="d-block d-lg-none d-xl-none bg-pattern-mobile">
    <img src="/assets/images/signup-v2/background-pattern.webp" alt="Background pattern" class="w-100" />
</section>

<section class="how-it-works py-5" aria-labelledby="howItWorksHeading">
    <div class="container text-center">
        <h2 id="howItWorksHeading" class="h5 fw-semibold mb-4">How it Works</h2>
        <div class="hitw-visual d-flex flex-column flex-md-row justify-content-between">
            <svg class="hitw-line d-none d-md-block" viewBox="0 0 100 8" preserveAspectRatio="none" aria-hidden="true"
                focusable="false">
                <line x1="0" y1="4" x2="100" y2="4" />
            </svg>
            <ol
                class="hitw-steps list-unstyled m-0 p-0 d-flex flex-column flex-md-row gap-4 gap-md-0 justify-content-between">
                @for (item of howItWorks; track $index) {
                <li class="hitw-step flex-fill">
                    <div class="icon-wrapper mx-auto">
                        <img [src]="item.image" [alt]="item.alt" />
                    </div>
                    <!-- <div class="number fw-semibold mt-3">{{ item.number }}</div> -->
                    <p class="title small mb-0 mt-4">{{ item.title1 }}</p>
                    <p class="title small mb-3 mt-0">{{ item.title2 }}</p>
                    <p class="description small mb-0">{{ item.text }}</p>
                </li>
                }
            </ol>
        </div>
    </div>
</section>
<app-faqs class="animated fadeInUp" [step]="currentIndex"></app-faqs>
<app-footer class="animated fadeInUp"></app-footer>